<script setup lang="ts">
definePageMeta({
    hidePromotions: true
})

const { site } = useCoreConfig()

// SEO - START
const { data: pageData } = await usePageData('ansvarligt-spil')

const { getHead, getSeoMeta } = useStrapiSeo(
    pageData.value?.seo || {
        metaTitle: `Ansvarligt spil | ${site.name} opfordrer til ansvarligt spil`,
        metaDescription: `${site.name} opfordrer alle brugere til ansvarligt spil. Find mere information, guides og rådgivning her.`
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
// SEO - END
</script>

<template>
    <div>
        <SaferGamblingApp />
    </div>
</template>
